
module.exports = ['$translate', function ($translate) {
  // 对多次转发回复的邮件主题简化显示
  return function (text) {
    const iText = text.replace(/：/g, ':')
    const separateTextArr = iText.split(':')
    const firstWord = separateTextArr[0]
    const keywordArr = ['回复', '回復', 'reply', 're', '转发', '轉發', 'forward', 'fw']
    if (~keywordArr.indexOf(firstWord.toLowerCase())) {
      // 计算出现回复转发相关关键词的次数
      let keywordCount = 0
      keywordArr.forEach(function (keyword) {
        const regx = new RegExp(keyword, 'ig')
        separateTextArr.forEach(function (item) {
          const result = item.toLowerCase().trim().match(regx)
          if (result) {
            keywordCount = keywordCount + result.length
          }
        })
      })
      let subjectStartIndex
      const len = separateTextArr.length
      const newTextArr = []
      // 次数大于2时获取邮件主题，拼接精简主题
      if (keywordCount > 2) {
        for (let i = 0; i < len; i++) {
          if (!~keywordArr.indexOf(separateTextArr[i].toLowerCase().trim())) {
            subjectStartIndex = i
            break
          }
        }
        for (let i = subjectStartIndex; i < len; i++) {
          newTextArr.push(separateTextArr[i])
        }
        return firstWord + '...' + newTextArr.join(':')
      } else {
        return text
      }
    } else {
      return text
    }
  }
}]



// WEBPACK FOOTER //
// ./src/js/mail/mutilForwardReplySimplifyFilter.js